@if (isMulti()) {
  <elcia-multi-dropdown [control]="control()"
                        [items]="states()"
                        [label]="'todo.states'"
                        [textField]="'label'"
                        [valueField]="'id'">
  </elcia-multi-dropdown>
} @else {
  <elcia-dropdown [control]="control()"
                  [items]="states()"
                  [label]="'todo.status'"
                  [scrollHeight]="'140px'"
                  [textField]="'label'"
                  [valueField]="'id'">
  </elcia-dropdown>
}
